import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const getUnregisteredPotentials = async (setData, companyId, name, page) => {
  return await axios.get(`company-potentials/companies/${companyId}/unregistered/search-page?name=${encodeURIComponent(name)}&page=${page}`)
    .then((response) => {
      setData(response.data.data);
    })
    .catch(() => {});
};

export default getUnregisteredPotentials;